"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDisabledReportingInterface = void 0;
const createDisabledReportingInterface = (config) => {
    const reportingServiceName = "disabled";
    const captureException = (error) => {
        return;
    };
    const setTags = (tags) => { };
    const setTag = (key, value) => { };
    return {
        reportingServiceName,
        captureException,
        setTag,
        setTags,
        instance: null,
    };
};
exports.createDisabledReportingInterface = createDisabledReportingInterface;
